import React, { useEffect } from 'react';
import AOS from 'aos';

import Redirect from '../../../../CommonComponents/Redirect/Redirect';
import { HeaderJunni } from './HeaderJunni';
import { BodyJunni } from './BodyJunni';
import { FooterJunni } from './FooterJunni';

import './BaseJunni.scss';

const JunniLP = () => {
  const baseImgUrl = 'https://static.lenskart.com/owndays/img/junni';
  const now = new Date();
  const isPreProd = process.env.ENVIRONMENT === 'preprod';
  const releaseTime = new Date('2025-07-18T10:00:00+08:00');

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!isPreProd && now < releaseTime) {
    return <Redirect to="/" />;
  }

  return (
    <div className="base-junni">
      <HeaderJunni baseImgUrl={baseImgUrl} />
      <BodyJunni baseImgUrl={baseImgUrl} />
      <FooterJunni />
    </div>
  );
};

export default JunniLP;
